.ux-w-empty {
    overflow: hidden;
    width: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &__background {
        position: absolute;
        font-size: 500px;
        top: 10px;
        left: 50px;
        opacity: 0.04;

        [fill] {
            fill: $color-black;
        }
    }

    &__inner {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        max-width: 600px;
        transform: translate(-50%, -50%);
        text-align: center;
    }

    &__icon {
        font-size: 120px;
    }

    &__text {
        @include font(light);
        line-height: 1.375em;
        margin-top: $dim-5;
        padding: 0 $dim-10;

        strong {
            @include font(bold);
        }
    }

    &__text-content {
        font-size: $size-text-normal;

        p {
            color: $color-grey-text-light;
            font-size: $size-text-medium-plus;
            line-height: 1.375em;
            margin-top: $size-text-medium-plus;
        }
    }

    &__link {
        margin-top: 20px;
    }
}
